<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
			  <el-breadcrumb-item>我的推荐</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button"></div>
		</div>
		<div class="tuiguang">
			<div class="tuiguangbox">
				<div class="tuiguangbox1">
					<img src="@/assets/nav51.png" alt="" sizes="" srcset="" />
					<div class="tuiguangbox1_1">
						<img src="@/assets/shou1.png" alt="" srcset="" />
						<div>
							<p>总收益(元)</p>
							<span>￥{{user.total_brokerage_money|| '0.00'}}</span>
						</div>
					</div>
				</div>
				<div class="tuiguangbox1">
					<img src="@/assets/nav11.png" alt="" sizes="" srcset="" />
					<div class="tuiguangbox1_1">
						<img src="@/assets/shou2.png" alt="" srcset="" />
						<div>
							<p>冻结中(元)</p>
							<span>￥{{user.frozen_brokerage_money|| '0.00'}}</span>
						</div>
					</div>
				</div>
				<div class="tuiguangbox1">
					<img src="@/assets/nav21.png" alt="" sizes="" srcset="" />
					<div class="tuiguangbox1_1">
						<img src="@/assets/shou3.png" alt="" srcset="" />
						<div>
							<p>推广人数</p>
							<span>{{zongren || '0'}}人</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="tixiang">
			<img src="@/assets/jg.png" alt="" srcset="" />
			<span>需求方确认验收后可提现，用户退款，佣金将被收回。PC端不支持提现，请使用小程序进行提现操作。</span>
		</div>
		<div class="table">
			<ul class="tableUl">
				<li :class="{'csnu':lxtype==1}" @click="qiehuan(1)">
					<span>邀请列表</span>
					<div v-if="lxtype==1"></div>
				</li>
				<li :class="{'csnu':lxtype==2}"  @click="qiehuan(2)">
					<span>奖励明细</span>
					<div v-if="lxtype==2"></div>
				</li>
			</ul>
			<el-table
			      v-if="lxtype==1"
			      :data="yqlist"
			      style="width: 100%">
			      <el-table-column
			        prop="nickname"
			        label="被邀请人"
			        width="443">
					<template slot-scope="scope">
						<div class="userinfo">
							<img :src="scope.row.avatar" alt="" srcset="" />
							<span>{{scope.row.nickname}}</span>
						</div>
					</template>
			      </el-table-column>
			      <el-table-column
			        prop="create_time"
			        label="绑定时间"
			        width="443">
			      </el-table-column>
			      <el-table-column
			        prop="address"
			        label="用户类型">
					<template slot-scope="scope">
						<div class="userinfo">
							 <span v-if="scope.row.user_type==1">需求方</span>
							 <span v-if="scope.row.user_type==2">服务方</span>
						</div>
					</template>
			      </el-table-column>
			</el-table>
			
			<el-table
			      v-if="lxtype==2"
			      :data="paylist"
			      style="width: 100%">
			      <el-table-column
			        prop="date"
			        label="成交人员"
			        width="313">
					<template slot-scope="scope">
						<div class="userinfo">
							<img :src="scope.row.fromUser.avatar" alt="" srcset="" />
							<span>{{scope.row.fromUser.nickname}}</span>
						</div>
					</template>
			      </el-table-column>
			      <el-table-column
			        prop="desc"
			        label="佣金收益"
			        width="280">
			      </el-table-column>
			      <el-table-column
			        prop="create_time"
			        label="下单时间"
					width="230">
			      </el-table-column>
				  <el-table-column
				    prop="price"
				    label="佣金金额"
				  	width="180">
				  </el-table-column>
				  <el-table-column
				    prop="status"
				    label="状态"
				  	>
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status==1">已完成</el-tag>
						<el-tag v-if="scope.row.status==0" type="warning">冻结中</el-tag>
						<el-tag v-if="scope.row.status==-1" type="info">已退回</el-tag>
					</template>
				  </el-table-column>
			</el-table>
			
			<div class="fenye" v-if="total>10">
			   <el-pagination
				 background
				 @current-change="handleCurrentChange"
				 :current-page.sync="currentPage1"
				 :page-size="9"
				 layout="total, prev, pager, next ,jumper"
				 :total="total">
			   </el-pagination>
			</div>
			
		</div>
	</div>
</template>

<script>
	import {
		personal,
		inviteList,
		billList
	} from "@/api/api.js"
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
		    lxtype:"1",
			navtype:1,
			page:1,
			user:"",
			yqlist:[],
			paylist:[],
			total:0,
			zongren:""
	    }
	  },
	  created() {
	  	this.getpersonal()
	  	this.getinviteList()
	  },
	  methods: {
		qiehuan(index){
			this.lxtype=index
			this.page=1
			if(this.lxtype==1){
				 this.getinviteList()
			}else{
				 this.getbillList()
			}
		},
		handleCurrentChange(e){
			this.page=e
			if(this.lxtype==1){
				 this.getinviteList()
			}else{
				 this.getbillList()
			}
		},
		getpersonal(){
			personal({}).then(res=>{
				this.user=res.data
			})
		},
		//邀请好友列表
		getinviteList(){
			inviteList({
				page:this.page,
				limit:"10"
			}).then(res=>{
				this.zongren=res.data.data.total
				this.total=res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
				this.yqlist=res.data.data.data
			})
		},
		//资金明细
		getbillList(){
			billList({
				page:this.page,
				limit:"10",
				type:'1',
				status:""
			}).then(res=>{
				this.total=res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
				this.paylist=res.data.data.data
			})
		},
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.tuiguang{
		width: 1200px;
		margin: 0 auto;
	}
	.tuiguangbox{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.tuiguangbox1{
		width: 384px;
		height:120px;
		overflow:hidden;
		position:relative;
	}
	
	.tuiguangbox1>img{
		width:100%;
		height:100%;
	}
	.tuiguangbox1_1{
		width: 384px;
		height:120px;
		position:absolute;
		z-index:1;
		padding:20px;
		box-sizing: border-box;
		top: 0;
		display: flex;
		align-items: center;
	}
	.tuiguangbox1_1>img{
		width:60px;
		height:60px;
		margin-right:20px;
	}
	.tuiguangbox1_1 p{
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
	}
	.tuiguangbox1_1 span{
		font-weight: bold;
		font-size: 24px;
		color: #FFFFFF;
	}
	.tixiang{
		width:1200px;
		margin:0 auto;
		height:33px;
		background-color:#DBDEE7;
		display:flex;
		align-items:center;
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
		padding:0px 10px;
		box-sizing: border-box;
		border-radius:8px;
		margin-top:16px;
		margin-bottom:20px;
	}
	.tixiang img{
		width:16px;
		height:16px;
		margin-right:10px;
	}
	.table{
		width:1200px;
		margin:0 auto;
		background-color:#fff;
		padding:20px;
		box-sizing: border-box;
		border-radius:8px;
		margin-top:16px;
	}
	.tableUl{
		width:100%;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.tableUl li{
		margin:20px;
		position:relative;
		cursor:pointer;
		font-weight: 400;
		font-size: 16px;
		color: #666666;
		padding-bottom:15px;
		box-sizing: border-box;
	}
	.tableUl div{
		width:24px;
		height:3px;
		background: #1E3A8A;
		border-radius: 10px;
		position:absolute;
		bottom: 0;
		left:50%;
		margin-left:-12px;
	}
	.csnu{
		color: #1E3A8A !important;
	}
	.userinfo{
		display:flex;
		align-items:center;
	}
	.userinfo img{
		width:32px;
		height:32px;
		margin-right:10px;
		border-radius:50%;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		padding-top:30px;
	}
</style>